"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OFFSET_ERROR = exports.DEFAULT_COLOR = exports.EASE_IN_OUT = void 0;
exports.EASE_IN_OUT = 'cubic-bezier(0.37, 0, 0.63, 1)';
exports.DEFAULT_COLOR = '#1e1e1e';
exports.OFFSET_ERROR = 5;
//# sourceMappingURL=const.js.map